import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles/enums';
import { map, Observable } from 'rxjs';

import { LocalDate } from '@fcom/core/utils';
import { DatepickerTheme } from '@fcom/service-forms/components/common/datepicker.component';
import { SelectOption } from '@fcom/common';
import { LanguageService } from '@fcom/ui-translate';
import { finShare } from '@fcom/rx';
import { PassportDetailsForm } from '@fcom/common/interfaces/corporate/corporate.interface';

@Component({
  selector: 'fin-passport-details-form',
  templateUrl: './passport-details-form.component.html',
  styleUrls: ['./passport-details-form.component.scss'],
})
export class PassportDetailsFormComponent implements OnInit {
  protected readonly DatepickerTheme = DatepickerTheme;
  protected readonly SvgLibraryIcon = SvgLibraryIcon;

  currentDate = LocalDate.now();
  expiryMinDate = LocalDate.now().minusYears(15);
  expiryMaxDate = LocalDate.now().plusYears(15);

  nationalities$: Observable<SelectOption[]>;

  @Input() formGroup: FormGroup<PassportDetailsForm>;

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    this.nationalities$ = this.languageService.translate('countryCodes').pipe(
      map((codes) =>
        codes
          .map((code) => ({ value: code.countryCode, name: code.nationality ?? code.name }))
          .sort((a, b) => a.name.localeCompare(b.name))
      ),
      finShare()
    );
  }
}
